import { ForOrganizations } from '@/domains/Demo/pages/ForOrganizations';
import PageLayout from '@/widgets/PageLayout';
import React from 'react';

const ForOrganizationsPage: React.FC = () => {
  return (
    <PageLayout>
      <ForOrganizations />
    </PageLayout>
  );
};

export default ForOrganizationsPage;
